import React from 'react';
import { FooterElement, GridContainer } from '@/components/footer/Footer/Footer.styles';
import { Container } from '@/components/container';
import HeadingGroup from '@/components/footer/HeadingGroup/HeadingGroup';
import FooterNavlink from '@/components/footer/FooterNavlink/FooterNavlink';
import { Text } from '@/components/typography';
import { FooterBottomLine } from '@/components/footer';
import { urlPacotes } from '@/config/url';
import FormSubscriber from '@/features/forms/FormSubscriber/FormSubscriber';
import ExchangeRates from '@/components/exchange/ExchangeRates';
import { useAppContext } from '@/context/AppContext';
import { useTranslations } from 'next-intl';

export interface FooterProps {
  className?: string;
}

const Footer = ({ ...props }: FooterProps) => {
  const t = useTranslations('Footer');
  const { navigation } = useAppContext();
  const { footer } = navigation || {};

  if (footer === undefined) return null;

  return (
    <FooterElement>
      <Container>
        <GridContainer>
          <div>
            <HeadingGroup>{t('viagens nacionais e internacionais')}</HeadingGroup>
            <ul>
              {footer.pacotesMenu.map((item) => (
                <li key={item.slug}>
                  <FooterNavlink href={urlPacotes(item.slug)}>{item.title}</FooterNavlink>
                </li>
              ))}
            </ul>
            <FooterNavlink href="/pacotes">
              {t('Todos os destinos')} {`>`}
            </FooterNavlink>
          </div>

          <div>
            <HeadingGroup>{t('para sua viagem')}</HeadingGroup>
            <ul>
              {footer.paraSuaViagemMenu.map((item) => (
                <li key={item.id}>
                  <FooterNavlink href={item.href} aria-label={item.title}>
                    {item.title}
                  </FooterNavlink>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <HeadingGroup>newsletter</HeadingGroup>
            <Text size="xs" margin="sm">
              {t(
                'assine a nossa newsletter para receber ofertas exclusivas e as últimas notícias sobre nossos produtos e serviços'
              )}
              .
            </Text>
            <FormSubscriber />
          </div>

          <div>
            <HeadingGroup>{t('informações úteis')}</HeadingGroup>
            <ul>
              {footer.usefulInfo.contents.map((item) => (
                <li key={`usefull-${item.slug}`}>
                  <FooterNavlink href={item.permalink} target={item.slug === 'blog' ? '_blank' : undefined}>
                    {item.title}
                  </FooterNavlink>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <HeadingGroup>{t('sobre a kangaroo')}</HeadingGroup>
            <ul>
              {footer.quemSomosMenu.map((item) => (
                <li key={item.id}>
                  <FooterNavlink href={item.href} aria-label={item.title}>
                    {item.title}
                  </FooterNavlink>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <HeadingGroup>{t('câmbio do dia')}</HeadingGroup>
            <ExchangeRates appearance="vertical" />
          </div>

          <div>
            <HeadingGroup>{t('redes sociais')}</HeadingGroup>
            <Text size="sm" weight="bold" margin="base">
              {t('Siga a Kangaroo')}
            </Text>
            <ul>
              {footer.socialMediaMenu.map((item) => (
                <li key={item.id}>
                  <FooterNavlink href={item.href} target="_blank" className={item.id}>
                    <span>{item.title}</span>
                  </FooterNavlink>
                </li>
              ))}
            </ul>
          </div>
        </GridContainer>
        <FooterBottomLine bottomNavMenu={footer.bottomNavMenu} />
      </Container>
    </FooterElement>
  );
};

export default Footer;
